module.exports = __webpack_public_path__ + "media/alaska/valley-793d92b7.jpg";